var e=e=>e.map(e=>{const{valueGetter:t,renderCell:r,valueFormatter:a}=e;return t||r||a?e:{...e,valueGetter:e=>e||"-"}});export{e as addDefaultValueGetter};
//# sourceMappingURL=addDefaultValueGetter.js.map